import paxPlannerConfig from './pax/paxPlannerConfig';
import bestaPlannerConfig from './besta/bestaPlannerConfig';
import platsaPlannerConfig from './platsa/platsaPlannerConfig';
import { ConfigOptions } from './@types';
import eketPlannerConfig from './eket/eketPlannerConfig';
import smastadPlannerConfig from './smastad/smastadPlannerConfig';
import ivarPlannerConfig from './ivar/ivarPlannerConfig';
import billyPlannerConfig from './billy/billyPlannerConfig';
import brorPlannerConfig from './bror/brorPlannerConfig';
import kallaxPlannerConfig from './kallax/kallaxPlannerConfig';
import boaxelPlannerConfig from './boaxel/boaxelPlannerConfig';
import ladmakarePlannerConfig from './ladmakare/ladmakarePlannerConfig';
import jonaxelPlannerConfig from './jonaxel/jonaxelPlannerConfig';
import elvarliPlannerConfig from './elvarli/elvarliPlannerConfig';
import knoxhultPlannerConfig from './knoxhult/knoxhultPlannerConfig';
import aurdalPlannerConfig from './aurdal/aurdalPlannerConfig';
import { Range } from 'utils/range';

/**
 * Defaults to PAX
 */
export const getPlannerConfig = (range: Range, options?: ConfigOptions) => {
  switch (range) {
    case 'besta':
      return bestaPlannerConfig(options);
    case 'platsa':
      return platsaPlannerConfig(options);
    case 'eket':
      return eketPlannerConfig(options);
    case 'smastad':
      return smastadPlannerConfig(options);
    case 'ivar':
      return ivarPlannerConfig(options);
    case 'bror':
      return brorPlannerConfig(options);
    case 'billy':
      return billyPlannerConfig(options);
    case 'kallax':
      return kallaxPlannerConfig(options);
    case 'boaxel':
      return boaxelPlannerConfig(options);
    case 'ladmakare':
      return ladmakarePlannerConfig(options);
    case 'jonaxel':
      return jonaxelPlannerConfig(options);
    case 'elvarli':
      return elvarliPlannerConfig(options);
    case 'knoxhult':
      return knoxhultPlannerConfig(options);
    case 'aurdal':
      return aurdalPlannerConfig(options);
    default:
      return paxPlannerConfig(options);
  }
};
